__turbopack_context__.v({
  "className": "instrument_serif_c78bc0a8-module__kdhDaG__className",
});
